

<template>

<div id="chart">
    <apex-chart type=donut :height="height" :options="chartOptions" :series="series" />
</div>

</template>

<script>

import VueApexCharts from 'vue-apexcharts'

export default {
    components: {
        "ApexChart": VueApexCharts,
    },
    props: ["category", "height"],
    data() {
        return {
            series: [this.category.meta_chunks_label_topic_ux_count, this.category.meta_chunks_label_topic_support_count, this.category.meta_chunks_label_topic_price_count],
            chartOptions: {

                dataLabels: {
                    enabled: false,
                },
                plotOptions: {
                },
                title: {
                  text: "Users are talking about",
                  align: "left",
                  floating: true,
                  style: {
                    fontSize: "10px"
                  }
                },
                labels: ['User Experience', 'Support', 'Price'],
            }
        }
    },
}

</script>
